import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "flex justify-center gap-2" };
var _hoisted_2 = { class: "ml-4" };
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-4" }, null, -1);
var _hoisted_4 = { class: "flex justify-center gap-2" };
var _hoisted_5 = { class: "flex justify-center gap-2" };
import BaseInput from "../components/BaseInput.vue";
import BaseOutput from "../components/BaseOutput.vue";
import BaseButtons from "../components/BaseButtons.vue";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'baseAlPesoCalculator',
    props: {
        peso: {},
        altezza: {}
    },
    setup: function (__props) {
        var props = __props;
        var dose = ref();
        var dosemq = ref();
        var somministrazioni = ref();
        var dose_totale = ref("...");
        var dose_singola = ref("...");
        var doseValid = ref("");
        var dosemqValid = ref("");
        var somministrazioniValid = ref("");
        function calculator() {
            var supCorporea = Math.sqrt((props.altezza * props.peso) / 3600);
            if (dose.value != 0 && !(isNaN(dose.value))) {
                dose_totale.value = props.peso * dose.value;
            }
            else {
                dose_totale.value = Math.round(supCorporea * dosemq.value);
            }
            somministrazioni.value = somministrazioni.value == 0 ? 1 : somministrazioni.value;
            dose_singola.value = Math.round(dose_totale.value / somministrazioni.value);
            dose_totale.value = isNaN(dose_totale.value) ? 0 : dose_totale.value;
            dose_singola.value = isNaN(dose_singola.value) ? 0 : dose_singola.value;
        }
        function eraser(field) {
            field.value = "";
        }
        function resetForm() {
            // Cancellazione valori inseriti
            eraser(dose);
            eraser(dosemq);
            eraser(somministrazioni);
            // Cancellazione valori calcolati
            dose_totale.value = "...";
            dose_singola.value = "...";
            // Cancellazione validatori
            eraser(doseValid);
            eraser(dosemqValid);
            eraser(somministrazioniValid);
        }
        function checkInputValidity(field) {
            switch (field) {
                case 'doseKg':
                    if (isNaN(dose.value) || dose.value < 0 || dose.value > 10) {
                        doseValid.value =
                            "Controlla il valore inserito. Il valore deve essere compreso tra 0 e 10.";
                    }
                    else {
                        eraser(doseValid);
                    }
                    break;
                case 'doseMq':
                    if (isNaN(dosemq.value) || dosemq.value < 0 || dosemq.value > 10) {
                        dosemqValid.value =
                            "Controlla il valore inserito. Il valore deve essere compreso tra 0 e 10.";
                    }
                    else {
                        eraser(dosemqValid);
                    }
                    break;
                case 'somministrazioni':
                    if (isNaN(somministrazioni.value) || somministrazioni.value < 0 || somministrazioni.value > 10) {
                        somministrazioniValid.value =
                            "Controlla il valore inserito.. Il valore deve essere compreso tra 1 e 10.";
                    }
                    else {
                        eraser(somministrazioniValid);
                    }
                    break;
                default:
                    break;
            }
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(BaseInput, {
                            label: _ctx.$t('Dose (mg/Kg)'),
                            type: "number",
                            placeholder: "mg/Kg",
                            modelValue: _unref(dose),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(dose) ? (dose).value = $event : dose = $event); }),
                            onValidateInput: _cache[1] || (_cache[1] = function ($event) { return (checkInputValidity('doseKg')); }),
                            isInputValid: _unref(doseValid),
                            disabled: _unref(dosemq) > 0
                        }, null, 8, ["label", "modelValue", "isInputValid", "disabled"]),
                        _createVNode(BaseInput, {
                            label: _ctx.$t('Dose (mg/mq)'),
                            type: "number",
                            placeholder: "mg/mq",
                            modelValue: _unref(dosemq),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return (_isRef(dosemq) ? (dosemq).value = $event : dosemq = $event); }),
                            onValidateInput: _cache[3] || (_cache[3] = function ($event) { return (checkInputValidity('doseMq')); }),
                            isInputValid: _unref(dosemqValid),
                            disabled: _unref(dose) > 0
                        }, null, 8, ["label", "modelValue", "isInputValid", "disabled"]),
                        _createVNode(BaseInput, {
                            label: _ctx.$t('Somministrazioni'),
                            type: "number",
                            placeholder: "1",
                            modelValue: _unref(somministrazioni),
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return (_isRef(somministrazioni) ? (somministrazioni).value = $event : somministrazioni = $event); }),
                            onValidateInput: _cache[5] || (_cache[5] = function ($event) { return (checkInputValidity('somministrazioni')); }),
                            isInputValid: _unref(somministrazioniValid)
                        }, null, 8, ["label", "modelValue", "isInputValid"])
                    ]),
                    _hoisted_3
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(BaseButtons, {
                        onClearForm: resetForm,
                        onCalculate: calculator,
                        hiddenSalvaButton: ""
                    })
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(BaseOutput, {
                        class: "flex text-sm basecolor-mr",
                        label: _ctx.$t('Dose Totale'),
                        key: "number",
                        result: _unref(dose_totale),
                        unit: "mg"
                    }, null, 8, ["label", "result"]),
                    _createVNode(BaseOutput, {
                        class: "flex text-sm basecolor-mr",
                        label: _ctx.$t('Dose Singola'),
                        key: "number",
                        result: _unref(dose_singola),
                        unit: "mg"
                    }, null, 8, ["label", "result"])
                ])
            ], 64));
        };
    }
});
